import { handleShowMessageNotification } from '../common/handleShowMessageNotification';

export const showMessageNotification = ({ data: { message, templateId } }) =>
    handleShowMessageNotification({ message, templateId });
